import * as React from 'react';
import { DialogCloseButton } from '../../atoms/DialogCloseButton/DialogCloseButton'; //needs to update to path aliases
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import { styled } from '@mui/material';
import { Typography, BasicButton } from '../../atoms';

export interface PopUpModalProps extends DialogProps {
    title: string;
    description: React.ReactNode;
    saveButtonLabel?: string;
    cancelButtonLabel?: string;
    saveButtonEndIcon?: React.ReactNode;
    titleVariant?: 'default' | 'primary';
    showTitle?: boolean;
    showCancelButton?: boolean;
    handleClose: () => void;
    handleSaveButtonAction: () => void;
    titleBold?: boolean;
    boldCloseButton?: boolean;
    width?: string;
    height?: string;
    footerComp?: React.ReactNode;
    subTitle?: string;
}

interface StyledTitleExtraProps {
    $variant?: 'default' | 'primary';
    $bold?: boolean;
}

interface StyledDialogExtraProps {
    $width?: string;
    $height?: string;
}

const StyledDialog = styled(Dialog)<DialogProps & StyledDialogExtraProps>(({ $width, $height }) => ({
    '& .MuiDialog-paper': {
        width: $width ?? 'auto',
        ...($width ? { maxWidth: 'calc(100% - 64px)' } : {}),
        height: $height ?? 'auto',
        ...($height ? { maxHeight: 'none' } : {})
    }
}));

const StyledDialogTitle = styled(DialogTitle)<DialogTitleProps & StyledTitleExtraProps>(
    ({ theme, $variant, $bold }) => ({
        color: $variant === 'primary' ? theme.palette.primary[500] : 'initial',
        fontWeight: $bold ? 600 : 'normal'
    })
);

export const PopUpModal = ({
    title,
    description,
    saveButtonLabel,
    saveButtonEndIcon,
    handleClose,
    handleSaveButtonAction,
    cancelButtonLabel,
    showTitle = true,
    showCancelButton = true,
    titleVariant = 'default',
    titleBold = false,
    boldCloseButton = false,
    width,
    height,
    footerComp,
    subTitle,
    ...props
}: PopUpModalProps) => {
    return (
        <StyledDialog
            {...props}
            $width={width}
            $height={height}
            onClose={handleClose}
            aria-labelledby="popup-dialog-title"
            aria-describedby="popup-dialog-content"
        >
            {showTitle && (
                <>
                    <StyledDialogTitle id="popup-dialog-title" $variant={titleVariant} $bold={titleBold}>
                        {title}
                        {!!subTitle && <Typography label={subTitle} color="neutral.grey.500" variant="body.small" />}
                    </StyledDialogTitle>
                    <DialogCloseButton bold={boldCloseButton} handleClose={handleClose} />
                </>
            )}
            <DialogContent dividers id="popup-dialog-content">
                {description}
            </DialogContent>
            <DialogActions>
                {footerComp && footerComp}
                {!footerComp && showCancelButton && (
                    <BasicButton onClick={handleClose} variant="outlined">
                        {cancelButtonLabel}
                    </BasicButton>
                )}
                {!footerComp && (
                    <BasicButton onClick={handleSaveButtonAction} variant="contained" endIcon={saveButtonEndIcon}>
                        {saveButtonLabel}
                    </BasicButton>
                )}
            </DialogActions>
        </StyledDialog>
    );
};
